import { useTranslation } from 'react-i18next';

export const NoDataComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="no-data-component w-100 d-flex justify-content-center align-items-center">
      <p className="no-table-data w-100 text-center">{t('global.noTableData')}</p>
    </div>
  );
};
